import script from "./StudentTermsContent.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentTermsContent.vue?vue&type=script&setup=true&lang=js"

import "./StudentTermsContent.vue?vue&type=style&index=0&id=19ad7c10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19ad7c10"]])

export default __exports__